import { gql, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation partialCopyMenu($baseMenuId: ID!, $productIds: [String!]!, $data: CopyMenuInput!) {
    copyPartialMenu(baseMenuId: $baseMenuId, productIds: $productIds, data: $data) {
      id
    }
  }
`;

export function useParitalCopyMenu() {
  return useMutation(MUTATION, {});
}
